(function () {
  const $blocks = document.querySelectorAll('section.ndc_cta_cards_block');
  const sliders = [];

  if (!$blocks.length) return;

  console.log('CTA Cards found. Setting them up...');

  $blocks
    .forEach($block => {
      const $interactiveVideos = $block.querySelectorAll('.interactive_video');
      const $dots = $block.querySelector('.embla__dots');
      const $prevBtn = $block.querySelector('.prev');
      const $nextBtn = $block.querySelector('.next');

      if ($block.classList.contains('template_1')) {
        if ((window.innerWidth <= 768 && !$block.classList.contains('mobile_template_stacked'))
        || window.innerWidth > 768 && $block.querySelectorAll('.card').length > 4) {
          $block.embla = EmblaCarousel(
            $block.querySelector('.embla__viewport'),
            {
              // dragFree: true,
              // loop: true
            },
            [
              // EmblaCarouselClassNames()
            ]
          );

          sliders.push($block.embla);
        }
      } else if ($block.classList.contains('template_2') && window.innerWidth <= 768) {
        $block.embla = EmblaCarousel(
          $block.querySelector('.embla__viewport'),
          {
            // dragFree: true,
            // loop: true
          },
          [
            // EmblaCarouselClassNames()
          ]
        );

        sliders.push($block.embla);
      } else if ($block.classList.contains('template_7')
      || $block.classList.contains('template_8')
      || $block.classList.contains('template_9')
      || $block.classList.contains('template_10')
      || $block.classList.contains('template_12')
      || $block.classList.contains('template_13')
      || $block.classList.contains('template_14')) {
        $block.embla = EmblaCarousel(
          $block.querySelector('.embla__viewport'),
          {
            dragFree: true,
            // loop: true
          },
          [
            // EmblaCarouselClassNames()
          ]
        );

        sliders.push($block.embla);
      }

      if ($block.embla) {
        if ($prevBtn) {
          $prevBtn.addEventListener('click', () => {
            $block.embla.scrollPrev();
          }, false);
        }

        if ($nextBtn) {
          $nextBtn.addEventListener('click', () => {
            $block.embla.scrollNext();
          }, false);
        }

        if ($prevBtn && $nextBtn) {
          $block.embla
            .on('init', checkPrevNext.bind($block))
            .on('reInit', checkPrevNext.bind($block))
            .on('select', checkPrevNext.bind($block));
        }

        if ($dots) {
          $block.embla
            .on('init', addPagingHandlers.bind($block))
            .on('reInit', addPagingHandlers.bind($block));

          $block.embla
            .on('init', checkPaging.bind($block))
            .on('reInit', checkPaging.bind($block))
            .on('select', checkPaging.bind($block));
        }
      }

      if ($interactiveVideos.length) {
        const $modal = document.querySelector('.ndc_downloads_modal');

        $interactiveVideos.forEach($interactiveVideo => {
          // on safari the first frame does not load so we need to seek to 0.001
          const $video = $interactiveVideo.querySelector('.video');
          $video.currentTime = 0.001;

          $video.addEventListener('loadedmetadata', () => {
            $video.currentTime = 0.002;
          });

          $modal.addEventListener('click', (ev) => {
            if (ev.target.closest('.close')
            || ev.target.classList.contains('ndc_downloads_modal')
            || ev.target.classList.contains('content')) {
              $modal.querySelector('.content').innerHTML = '';
              $modal.classList.remove('active');
              $modal.classList.remove('type_form');

              ev.preventDefault();
            }
          });

          $interactiveVideo
            .addEventListener('click', (ev) => {
              const $clonedMedia = $video.cloneNode(true);
              const $wrapperEl = document.createElement('div');

              $wrapperEl.classList.add('media_item', 'type_video');

              $wrapperEl.appendChild($clonedMedia);

              if (!$modal.classList.contains('active')) {
                $modal.classList.add('active');
              }

              $modal.querySelector('.content').innerHTML = '';
              $modal.querySelector('.content').appendChild($wrapperEl);

              $clonedMedia.classList.add('playing');
              $clonedMedia.controls = true;
              $clonedMedia.muted = false;
              $clonedMedia.addEventListener('loadedmetadata', () => {
                $clonedMedia.play();
              });
              $clonedMedia.src = $clonedMedia.dataset.full;

              ev.preventDefault();
            }, false);

          $interactiveVideo
            .addEventListener('mouseenter', () => {
              if (!$interactiveVideo.classList.contains('full')) {
                $interactiveVideo.classList.add('hover');
                $interactiveVideo.querySelector('.video').play();
              }
            }, false);

          $interactiveVideo
            .addEventListener('mouseleave', () => {
              if (!$interactiveVideo.classList.contains('full')) {
                $interactiveVideo.classList.remove('hover');
                $interactiveVideo.querySelector('.video').pause();
              }
            }, false);
        });
      }
    });

  function addPagingHandlers() {
    const $dotsWrapper = this.querySelector('.embla__dots');

    if ($dotsWrapper) {
      $dotsWrapper.innerHTML = this.embla
        .scrollSnapList()
        .map(() => '<button class="embla__dot" type="button"></button>')
        .join('');

      const scrollTo = (index) => {
        // stopAutoscroll(this);
        this.embla.scrollTo(index);
      };

      const $dots = Array.from($dotsWrapper.querySelectorAll('.embla__dot'));
      $dots.forEach(($dot, index) => {
        $dot.addEventListener('click', () => scrollTo(index), false)
      });
    }
  }

  function checkPaging() {
    const $dotsWrapper = this.querySelector('.embla__dots');

    if ($dotsWrapper) {
      const $dots = Array.from($dotsWrapper.querySelectorAll('.embla__dot'));
      const previous = this.embla.previousScrollSnap();
      const selected = this.embla.selectedScrollSnap();
      $dots[previous].classList.remove('embla__dot--selected');
      $dots[selected].classList.add('embla__dot--selected');
    }
  }

  function checkPrevNext() {
    const $prev = this.querySelector('.prev');
    const $next = this.querySelector('.next');

    if (!this.embla.canScrollPrev()) {
      $prev.classList.add('disabled');
    } else if ($prev.classList.contains('disabled')) {
      $prev.classList.remove('disabled');
    }

    if (!this.embla.canScrollNext()) {
      $next.classList.add('disabled');
    } else if ($next.classList.contains('disabled')) {
      $next.classList.remove('disabled');
    }
  }
})();